import { Howl, Howler } from "howler";

export const SoundSystem = new Howl({
  preload: false,
  src: [
    require("url:./gameaudio.ac3"),
    require("url:./gameaudio.ogg"),
    require("url:./gameaudio.m4a"),
    require("url:./gameaudio.mp3"),
  ],
  sprite: {
    hit: [0, 201.0657596371882],
    move: [2000, 115.01133786848072],
    pickup: [4000, 230.95238095238102],
    powerup: [6000, 223.24263038548776],
    stairs: [8000, 169.11564625850417],
  },
});
